// this hook is here as a workaround to the following bug/unexpected behaviour on apollo/client
// https://github.com/apollographql/react-apollo/issues/2601

import {DocumentNode, OperationVariables, QueryHookOptions, useQuery} from '@apollo/client';
import client from 'js/tool/graphql/client/apollo';

export function useCacheAndNetworkQuery<TData,  TVariables extends OperationVariables = OperationVariables>(
	query: DocumentNode,
	options?: QueryHookOptions<TData, TVariables>
) {
	const result = useQuery<TData, TVariables>(query, {...options, fetchPolicy: 'cache-and-network'});

	let inCache = true;

	if (result.loading) {
		try {
			if (client.readQuery({query, variables: options?.variables}) === null)  {
				inCache = false;
			}
		} catch (ex) {
			inCache = false;
		}
	}

	result.loading = !inCache;

	return result;
}
